<script>
import { groupBy, isNil, isObject } from "lodash";

export default {
  props: {
    cols: {
      type: Array,
      required: true
    },
    projetadoRows: {
      type: Array,
      default: () => []
    },
    projetadoEditable: Boolean,
    realizadoRows: {
      type: Array,
      default: () => []
    },
    realizadoEditable: Boolean,
    showRealizado: Boolean,
    competencias: {
      type: Array,
      default: () => []
    },
    disabledDetatch: Boolean,
    disabled: Boolean,
    editable: Boolean
  },
  data() {
    return {
      expandedIds: new Set()
    };
  },
  computed: {
    hasExpandedRows() {
      const rows = this.parsedProjetadoRows.concat(this.parsedRealizadoRows);
      return rows.some(
        ({ __expandData }) =>
          Array.isArray(__expandData) && __expandData.length > 0
      );
    },
    isSomeExpanded() {
      return this.expandedIds.size > 0;
    },
    parsedProjetadoRows() {
      return this.parseRows(this.projetadoRows, false);
    },
    parsedRealizadoRows() {
      return this.parseRows(this.realizadoRows, true);
    }
  },
  methods: {
    expandAll(expand) {
      if (expand) {
        const allExpandableItems = [
          ...this.parsedProjetadoRows,
          ...(this.showRealizado ? this.parsedRealizadoRows : [])
        ].filter(
          ({ __expandData }) =>
            Array.isArray(__expandData) && __expandData.length > 0
        );

        this.expandedIds = new Set(
          allExpandableItems.map(item => this.getItemKey(item))
        );
      } else {
        this.expandedIds.clear();
      }

      this.expandedIds = new Set(this.expandedIds);
    },
    getCellClass(text) {
      return {
        "text-center": text === " -- "
      };
    },
    getHeaderText(headerValue, headerText, firstHeader = false) {
      if (headerValue === "rubrica") {
        if (!this.showRealizado) {
          return "";
        }

        return firstHeader ? "Projetado" : "Realizado";
      }

      return headerText;
    },
    getItemKey(item) {
      return `${
        item.isRealizado ? "realizado" : "projetado"
      }-${item.rubrica_id || item.rubrica}`;
    },
    getRowClass(row) {
      return {
        "text-bold": ["Retorno Financeiro", "Custo", "VPL"].includes(
          row.rubrica
        )
      };
    },
    getSubitemClass(row) {
      return {
        "no-cursor":
          row.rubrica?.toLowerCase() === "outras despesas" || this.disabled
      };
    },
    getStyles(width) {
      return {
        maxWidth: `${width}px !important`,
        minWidth: `${width}px !important`,
        width: `${width}px !important`
      };
    },
    isExpanded(item) {
      const key = this.getItemKey(item);
      return this.expandedIds.has(key);
    },
    onContextMenu(event, row) {
      event.preventDefault();

      if (row.rubrica?.toLowerCase() === "outras despesas") {
        this.$notify({
          group: "geral",
          duration: 5000,
          type: "info",
          title: `Não é possível editar ${row.rubrica}`,
          text: "Para alterar este Custo, atualize a aba Outras Despesas."
        });
        return;
      }

      const menu = [
        {
          name: "Editar valores",
          cb: async () => {
            const eventName = row.isRealizado
              ? "click:edit-realizado"
              : "click:edit-projetado";
            this.$emit(eventName, row);
          }
        }
      ];

      if (!this.disabledDetatch && !row.isRealizado) {
        menu.push({
          name: "Desvincular",
          cb: async () => {
            this.$emit("click:detatch-projetado", row);
          }
        });
      }

      setTimeout(() => {
        this.showContext({
          left: event.clientX,
          top: event.clientY,
          val: row,
          col: {},
          menu
        });
      }, 100);
    },
    onProjetadoContextMenu(event, row) {
      if (this.projetadoEditable) {
        this.onContextMenu(event, row);
      }
    },
    onRealizadoContextMenu(event, row) {
      if (this.realizadoEditable) {
        this.onContextMenu(event, row);
      }
    },
    parseRows(rows, isRealizado) {
      const DEFAULT_GROUP_NAME = "none";
      const allMonths = this.competencias;
      const firstMonth = this.competencias[0];
      const toCurrencyValue = this.$options.filters.toCurrencyValue;
      const FIRST_LABEL = "Retorno Financeiro";
      const SECOND_LABEL = "Custo";
      const THIRD_LAST_LABEL = "Fluxo de Caixa Livre";
      const SECOND_LAST_LABEL = "Fluxo de Caixa Descontado";
      const LAST_LABEL = "VPL";

      const parsedRows = rows
        .map(
          ({
            competencias,
            rubrica,
            rubrica_id,
            tipo_rubrica,
            valor,
            ...rest
          }) => {
            let parsed = {
              ...rest,
              rubrica,
              rubrica_id,
              isHeader: [
                FIRST_LABEL,
                SECOND_LABEL,
                THIRD_LAST_LABEL,
                SECOND_LAST_LABEL,
                LAST_LABEL
              ].includes(rubrica),
              isRealizado,
              tipo_rubrica:
                isNil(tipo_rubrica) ||
                (isNil(rubrica_id) && tipo_rubrica === rubrica)
                  ? DEFAULT_GROUP_NAME
                  : tipo_rubrica,
              total: toCurrencyValue(valor || 0)
            };

            if (rubrica === LAST_LABEL) {
              const key = firstMonth;
              parsed[key] = toCurrencyValue(valor || 0);
              parsed.total = "";
              return parsed;
            }

            if (isObject(competencias) && !isNil(competencias)) {
              allMonths.forEach(key => {
                let value = " -- ";

                if (key in competencias) {
                  value =
                    typeof competencias[key] === "number"
                      ? toCurrencyValue(competencias[key])
                      : competencias[key];
                }

                parsed[key] = value;
              });
            }

            return parsed;
          }
        )
        .sort(({ rubrica: a = "" }, { rubrica: b = "" }) => {
          if (a === LAST_LABEL) return 1;
          if (b === LAST_LABEL) return -1;

          if (a === SECOND_LAST_LABEL) return 1;
          if (b === SECOND_LAST_LABEL) return -1;

          if (a === THIRD_LAST_LABEL) return 1;
          if (b === THIRD_LAST_LABEL) return -1;

          if (a === FIRST_LABEL) return -1;
          if (b === FIRST_LABEL) return 1;

          if (a === SECOND_LABEL) return -1;
          if (b === SECOND_LABEL) return 1;

          return a.localeCompare(b);
        });

      const groups = groupBy(parsedRows, "tipo_rubrica");
      const result = groups[DEFAULT_GROUP_NAME]?.map(row => {
        const subrows = groups[row.rubrica];

        if (Array.isArray(subrows) && subrows.length > 0) {
          return { ...row, __expandData: subrows };
        }

        return row;
      });

      return result ?? [];
    },
    toggleExpand(item) {
      const key = this.getItemKey(item);

      if (this.expandedIds.has(key)) {
        this.expandedIds.delete(key);
      } else {
        this.expandedIds.add(key);
      }

      this.expandedIds = new Set(this.expandedIds);
    }
  }
};
</script>

<template>
  <div class="vpl-unified-table">
    <v-data-table
      data-app
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
      hide-default-header
      :items="[]"
      no-data-text="Não existem dados para mostrar."
    >
      <template v-slot:header>
        <thead>
          <tr class="vpl-table-header">
            <th :style="getStyles(48)">
              <v-btn
                v-if="hasExpandedRows"
                icon
                @click.stop="expandAll(!isSomeExpanded)"
              >
                <v-icon v-if="isSomeExpanded">mdi-chevron-double-down</v-icon>
                <v-icon v-else>mdi-chevron-double-right</v-icon>
              </v-btn>
            </th>
            <template v-for="{ divider, text, value, width } of cols">
              <th :key="text" :class="{ divider }" :style="{ width }">
                {{ getHeaderText(value, text, true) }}
              </th>
            </template>
          </tr>
        </thead>
      </template>

      <template v-slot:body>
        <tbody>
          <template v-for="(item, index) of parsedProjetadoRows">
            <tr
              :key="'projetado' + index"
              :class="['vpl-table-row', getRowClass(item)]"
              @contextmenu.prevent
            >
              <td :style="getStyles(48)">
                <v-btn
                  v-if="item.__expandData"
                  icon
                  @click.stop="toggleExpand(item)"
                >
                  <v-icon v-if="isExpanded(item)">
                    mdi-chevron-double-down
                  </v-icon>
                  <v-icon v-else> mdi-chevron-double-right </v-icon>
                </v-btn>
              </td>
              <template v-for="{ divider, value, width } of cols">
                <td
                  :key="value"
                  :class="[{ divider }, getCellClass(item[value])]"
                  :style="getStyles(width)"
                >
                  {{ item[value] }}
                </td>
              </template>
            </tr>

            <template v-if="isExpanded(item) && item.__expandData">
              <tr
                v-for="(subItem, subIndex) in item.__expandData"
                :key="'projetado-sub-' + index + '-' + subIndex"
                :class="[
                  'vpl-table-row',
                  'expanded-row',
                  getSubitemClass(subItem)
                ]"
                @contextmenu.prevent="onProjetadoContextMenu($event, subItem)"
              >
                <td :style="getStyles(48)"></td>
                <template v-for="{ divider, value, width } of cols">
                  <td
                    :key="value"
                    :class="[{ divider }, getCellClass(subItem[value])]"
                    :style="getStyles(width)"
                  >
                    {{ subItem[value] }}
                  </td>
                </template>
              </tr>
            </template>
          </template>

          <template v-if="showRealizado">
            <tr class="vpl-table-header">
              <th :style="getStyles(48)"></th>
              <template v-for="{ divider, text, value, width } of cols">
                <th :key="text" :class="{ divider }" :style="{ width }">
                  {{ getHeaderText(value, text, false) }}
                </th>
              </template>
            </tr>

            <template v-for="(item, index) of parsedRealizadoRows">
              <tr
                :key="'realizado' + index"
                :class="['vpl-table-row', getRowClass(item)]"
                @contextmenu.prevent
              >
                <td :style="getStyles(48)">
                  <v-btn
                    v-if="item.__expandData"
                    icon
                    @click.stop="toggleExpand(item)"
                  >
                    <v-icon v-if="isExpanded(item)">
                      mdi-chevron-double-down
                    </v-icon>
                    <v-icon v-else>mdi-chevron-double-right</v-icon>
                  </v-btn>
                </td>
                <template v-for="{ divider, value, width } of cols">
                  <td
                    :key="value"
                    :class="[{ divider }, getCellClass(item[value])]"
                    :style="getStyles(width)"
                  >
                    {{ item[value] }}
                  </td>
                </template>
              </tr>

              <template v-if="isExpanded(item) && item.__expandData">
                <tr
                  v-for="(subItem, subIndex) in item.__expandData"
                  :key="'realizado-sub-' + index + '-' + subIndex"
                  :class="[
                    'vpl-table-row',
                    'expanded-row',
                    getSubitemClass(subItem)
                  ]"
                  @contextmenu.prevent="onRealizadoContextMenu($event, subItem)"
                >
                  <td :style="getStyles(48)"></td>
                  <template v-for="{ divider, value, width } of cols">
                    <td
                      :key="value"
                      :class="[{ divider }, getCellClass(subItem[value])]"
                      :style="getStyles(width)"
                    >
                      {{ subItem[value] }}
                    </td>
                  </template>
                </tr>
              </template>
            </template>
          </template>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<style lang="scss" scoped>
.vpl-unified-table {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: auto;
  width: 100%;

  .v-data-table {
    min-width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    table-layout: fixed;

    &::v-deep > .v-data-table__wrapper {
      flex: 1 1 auto;
      overflow: auto !important;
      height: 0;
      min-height: 0;

      & > table {
        border-collapse: separate;
        border-spacing: 0;
        width: 100%;

        td:first-child,
        th:first-child {
          position: sticky;
          left: 0;
          background-color: inherit;
          z-index: 3;
        }

        td:nth-child(2),
        th:nth-child(2) {
          position: sticky;
          left: 48px;
          background-color: inherit;
          z-index: 3;
        }

        th:first-child,
        th:nth-child(2) {
          z-index: 4;
        }
      }

      & > table {
        border-collapse: separate;
        border-spacing: 0;

        td:first-child,
        th:first-child {
          position: sticky;
          left: 0;
          background-color: inherit;
          z-index: 3;
        }

        td:nth-child(2),
        th:nth-child(2) {
          position: sticky;
          left: 48px;
          background-color: inherit;
          z-index: 3;
        }

        th:first-child,
        th:nth-child(2) {
          z-index: 4;
        }
      }
    }
  }

  .divider {
    border-right: 2px solid #f43336 !important;
  }

  tr.vpl-table-header {
    background-color: var(--v-table-header-base);

    th {
      text-align: center !important;
      color: #3e3e3f !important;
      position: sticky !important;
      top: 0;
      background-color: var(--v-table-header-base) !important;
      z-index: 3;

      &:first-child {
        left: 0;
        z-index: 4;
      }

      &:nth-child(2) {
        left: 48px;
        z-index: 4;
        text-align: left !important;
      }
    }
  }

  .vpl-table-row {
    background-color: #ffffff;

    &:hover {
      background-color: #e9ecef !important;
    }

    &.expanded-row {
      background-color: #e9ecef;

      &:hover {
        background-color: #d3d9df !important;
      }
    }

    td {
      text-align: right !important;
      height: 48px;

      &:nth-child(2) {
        text-align: left !important;
      }

      &.text-center {
        text-align: center !important;
      }
    }

    &.text-bold td {
      font-weight: bold;
    }
  }

  tbody tr:last-child {
    td {
      border-bottom: none;
    }
  }

  tbody::after {
    content: "";
    display: table-row;
    height: 100%;
  }
}
</style>
